<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Vote Results Options</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateVoteResultsOption()">
        <mat-icon>add</mat-icon>
        Add Vote Results Option
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="voteResultsOptions()"
      [columns]="voteResultsOptionsColumns"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditVoteResultsOption($event)"
      (deleteClick)="onDeleteVoteResultsOption($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
